import useUpdateEffect from '~/hooks/useUpdateEffect';

const datepickerIntl = ((locale) => {
    switch ( locale ) {
        case 'ru':
            return {
                days: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                monthsShort: ["Янв", "Фев", "Март", "Апр", "Май", "Июн", "Июл", "Авг", "Сент", "Окт", "Ноя", "Дек"],
            }
        case 'fr':
            return {
                days: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
                months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
            }
        case 'de':
            return {
                days: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
            }
        default:
            return {
                days: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            }
    }
})(window.locale)


export default function SearchRouteDate({
    isRange = false,
    value = '',
    hasError = false,
    dropDownParent = null,
    placeholder,
    onFocus,
    onChange,
})
{
    const inputRef = React.useRef()

    React.useEffect(() => {
        if (inputRef.current) {
            const dateEl = $(inputRef.current);

            if (isRange) {
                dateEl.daterangepicker({
                    opens: "center",
                    autoApply: true,
                    autoUpdateInput: false,
                    minDate: moment(),
                    locale: {
                        firstDay: 1,
                        customRangeLabel: "Custom",
                        daysOfWeek: datepickerIntl.days,
                        monthNames: datepickerIntl.months,
                    }
                }, function(startDate, endDate) {
                    let date = startDate.format('DD.MM.YYYY');
                    if(date !== endDate.format('DD.MM.YYYY')) date += ' - ' + endDate.format('DD.MM.YYYY')
                    onChange && onChange(date);
                })
            } else {

                let isOpen = false

                dateEl.datepicker({
                    autoHide: true,
                    weekStart: 1,
                    offset: 0,
                    startDate: moment(),
                    format: "DD.MM.YY",
                    daysMin: datepickerIntl.days,
                    months: datepickerIntl.months,
                    monthsShort: datepickerIntl.monthsShort,
                    container: dropDownParent,
                    pick: (event) => {
                        const date = dateEl.datepicker('getDate', true);
                        const date_formatted = moment(date, 'DD.MM.YY').format('DD.MM.YYYY');
                        onChange && onChange(date_formatted);
                    },
                    show: function () {
                        const instance = $(this).data("datepicker");
                        if (!instance || !instance.$picker) return;
                        const $picker = instance.$picker;
                        
                        $picker.removeClass("datepicker-animated");

                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                $picker.addClass("datepicker-animated");
                            });
                        });
                    },

                    hide: function () {
                        const instance = $(this).data("datepicker");
                        if (!instance || !instance.$picker) return;
                        instance.$picker.removeClass("datepicker-animated");
                    }
                });

                dateEl.on('show.datepicker', function (e) {
                    isOpen = true
                })
                dateEl.on('hide.datepicker', function (e) {
                    isOpen = false
                })

                $(window).scroll(function() {
                    if (isOpen) {
                        if (window.isAnimatedScrolling) {
                            dateEl.datepicker('hide')
                            dateEl.datepicker('show')
                        } else {
                            dateEl.datepicker('hide')
                            dateEl.blur()
                        }
                    }
                });
            }
        }
        
        
        return () => {
            if (inputRef.current) {
                if (isRange) {
                    $(inputRef.current).data('daterangepicker').remove();
                } else {
                    $(inputRef.current).datepicker('destroy');
                }
            }
        }
    }, [])

    const handleFocus = (e) => {
        $(e.target).select(); 
        onFocus && onFocus()
    }
    
    const handleChange = (value) => {
        if(value.trim() === '') onChange && onChange('')
    }
    
    let value_formatted = value ? moment(value, 'DD.MM.YYYY') : ''
    value_formatted = value_formatted && value_formatted.isValid() ? value_formatted.format('DD.MM.YY') : ''

    // Дата приходит в стейт программно (SEO-клик -> search.set, предсабмит),
    // сам пикер об этом не знает: синхронизируем его внутреннюю дату, иначе в календаре
    // остаётся выделено «сегодня». setDate без второго аргумента вызывает pick(),
    // который пишет в инпут ту же строку и бросает onChange с тем же значением — без цикла
    useUpdateEffect(() => {
        if (isRange || !inputRef.current || !value_formatted) return;
        const $el = $(inputRef.current);
        if ($el.data('datepicker')) {
            $el.datepicker('setDate', value_formatted);
        }
    }, [value_formatted])

    return <div className={cn('search-inputbox search-date', hasError && 'error')}>
        
        <input
            ref={inputRef}
            type="text"
            placeholder={placeholder || (isRange ? __('search.dateRange') : __('search.date'))}
            value={value_formatted}
            onFocus={e => handleFocus(e)}
            onChange={e => handleChange(e.target.value)}
        />
        
        {value && <a role='button'
                     className="search-inputbox__clear"
                     style={{display:'block'}}
                     onClick={() => handleChange('')}>
        </a>}
    </div>
}